import React from 'react';
import './App.css';
import Home from './components/home';
import Header from './components/header';
import Footer from './components/footer';
import { BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';

import Task from './components/task';
import Cert from './components/certifications';
import ProjectAdder from './components/ProjectAdder';

function App() {
  return (
  <Router>
    <div className="App">
      <Header/>
      <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/task/:ID" element={<Task />} />
         <Route path="/certifications" element={<Cert />} />
         <Route path="/ProjectAdder" element={<ProjectAdder />} />
      </Routes>
      <Footer/>
    </div>
    </Router>
  );
}

export default App;
